<div class="input-container">
  @if (label && labelType !== labelTypeOptions.PLACEHOLDER) {
    @if (labelType === labelTypeOptions.STATIC) {
      <div class="d-flex align-items-center">
        <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
        <!-- Tooltip -->
        @if (inputLabelTooltipText?.length) {
          <finxone-platform-tooltip
            [content]="inputLabelTooltipText"
            [textStyleClass]="tooltipTextStyleClass"
            [borderRadiusClass]="tooltipBorderRadiusClass"
          ></finxone-platform-tooltip>
        }
      </div>
    } @else {
      <ng-container [ngTemplateOutlet]="labelTemplate"></ng-container>
    }
  }

  <ng-template #labelTemplate>
    <label
      [class.labelActive]="isInputOnFocus"
      [class.floatingLabelWithValue]="control?.value && labelType === labelTypeOptions.FLOATING"
      [class.floatingLabel]="labelType === labelTypeOptions.FLOATING"
      class="labelText labelIdle labelConfig"
      [for]="id"
      (click)="handleLabelClick()"
      >{{ label }}</label
    >
  </ng-template>

  <div
    #inputElementWrapper
    class="input-wrapper position-relative"
    [style]="{ gap: spaceBetweenItem() }"
    (focusin)="onFocus()"
    (focusout)="onBlur()"
  >
    <div #autocompleteWrapper class="w-100">
      <hlm-autocomplete
        [inputIcon]="inputIcon"
        [toggleIcon]="toggleIcon"
        [inputId]="id"
        [filteredOptions]="filteredOptions"
        [value]="selectedOption"
        [search]="selectedOption?.[optionLabelKey]"
        [transformValueToSearch]="transformFn"
        [optionTemplate]="customOptionTemplate ?? defaultOptionTemplate"
        [searchPlaceholderText]="
          labelType === labelTypeOptions.PLACEHOLDER
            ? label
            : labelType === labelTypeOptions.FLOATING
              ? ''
              : placeholder
        "
        [loading]="loading"
        [disabled]="isDisabled"
        [class]="class"
        [textStylingClass]="textStylingClass"
        [borderRadiusClass]="borderRadiusClass"
        (valueChange)="onValueChange($event)"
        (searchChange)="onSearchChange($event)"
        [listStyles]="dropdownItemListStyles"
        [itemClass]="itemClass"
      ></hlm-autocomplete>
    </div>
  </div>

  <!-- Default option template -->
  <ng-template #defaultOptionTemplate let-option>
    <span [innerHTML]="option[optionLabelKey] | safeHtml"></span>
  </ng-template>

  <!-- Info text -->
  @if (helperText) {
    <ng-container>
      <div [innerHTML]="helperText | safeHtml"></div>
    </ng-container>
  }

  <!-- Validation errors -->
  @if (showErrors && control?.invalid && control?.touched) {
    <div class="error-container" role="alert">
      <div class="is-vertical-align mt-1">
        @for (error of control.errors | keyvalue; track error.key) {
          <small class="typog-xs text-error">
            {{ getErrorMessageBasedOnKey(error) }}
          </small>
        }
      </div>

      <!-- Custom Error Template -->
      @if (customErrorTemplate) {
        <ng-container
          [ngTemplateOutlet]="customErrorTemplate"
          [ngTemplateOutletContext]="{
            $implicit: {
              control: control,
              errors: control?.errors,
            },
          }"
        ></ng-container>
      }
    </div>
  }
</div>
